import React, { useEffect, useState } from 'react'
import Layout from 'Layout'
import { useNavigate } from 'react-router-dom'

const AiHub: React.FC = () => {
    const navigate = useNavigate()
    const [numberAccount, getNumberAccount] = useState('')

    const saveLocal = () => {
        localStorage.setItem('account_number', numberAccount)
        navigate('/account-live-metrix')
    }

    return (
        <Layout>
            <>
                <div id="lqd-titlebar" className="lqd-titlebar pt-6 pb-7 border-b transition-colors px-5 lg:px-10" layout-wide="1">
                    <div className="lqd-titlebar-container flex flex-wrap items-center justify-between gap-y-4 container-fluid">
                        <div className="lqd-titlebar-col lqd-titlebar-col-nav group/titlebar-nav flex w-full flex-col gap-2 lg:w-7/12">
                            <p className="lqd-titlebar-pretitle text-xs text-foreground/70 m-0">
                                <a
                                    className="lqd-btn group inline-flex items-center justify-center gap-1.5 text-xs font-medium rounded-button transition-all hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-link bg-transparent hover:underline hover:translate-y-0 hover:shadow-none focus-visible:underline p-0 focus-visible:translate-y-0 focus-visible:shadow-none focus-visible:outline-0 lqd-btn-size-none lqd-btn-hover-none text-inherit hover:text-foreground"
                                    href="/"
                                >
                                    <svg stroke-width="1.5" className="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                        <path d="M15 6l-6 6l6 6"></path>
                                    </svg>
                                    Back to dashboard
                                </a>
                            </p>
                            <h1 className="lqd-titlebar-title m-0">
                                AI Hub
                            </h1>
                        </div>

                        <div className="lqd-titlebar-col lqd-titlebar-col-actions group/titlebar-actions max-lg:has-[.max-lg\:hidden:only-child]:hidden flex w-full flex-wrap gap-y-3 lg:w-5/12 lg:justify-end">
                            <div className="lqd-titlebar-actions flex flex-wrap items-center gap-2"></div>
                        </div>

                        <div className="lqd-titlebar-after w-full">
                            <div className="flex flex-col gap-4 md:flex-row md:items-center">
                                <span className="relative">
                                    <svg
                                        className="pointer-events-none absolute start-3 top-1/2 z-1 size-5 -translate-y-1/2"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        stroke-width="2"
                                        stroke="currentColor"
                                        fill="none"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    >
                                        <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"></path>
                                        <path d="M21 21l-6 -6"></path>
                                    </svg>
                                    <div className="lqd-input-container relative">
                                        <input
                                            id=""
                                            className="lqd-input block peer w-full px-4 py-2 border border-input-border text-input-foreground text-base ring-offset-0 transition-colors focus:border-secondary focus:outline-0 focus:ring focus:ring-secondary dark:focus:ring-foreground/10 sm:text-2xs lqd-input-sm h-9 rounded-full border-none bg-clay ps-10"
                                            aria-label="Search in website"
                                            name=""
                                            value=""
                                            type="search"
                                            placeholder="Search"
                                            onKeyUp={(e) => {
                                                // TODO: Implement chatsFilter.setSearchStr logic here
                                                // Example: chatsFilter.setSearchStr(e.currentTarget.value);
                                            }}
                                        />
                                    </div>
                                </span>

                                <ul className="lqd-filter-list flex scroll-mt-6 flex-wrap items-center gap-x-4 gap-y-2 text-heading-foreground max-sm:gap-3" id="lqd-chats-filter-list">
                                    <li>
                                        <button
                                            name="filter"
                                            x-data="{}"
                                            className={`lqd-btn group items-center justify-center gap-1.5 font-medium rounded-button hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost bg-transparent text-foreground focus-visible:bg-foreground/10 lqd-btn-md lqd-btn-hover-none lqd-filter-btn inline-flex px-2.5 py-0.5 text-2xs leading-tight transition-colors hover:translate-y-0 hover:bg-foreground/5 [&.active]:bg-foreground/5 active`}
                                            type="button"
                                        >
                                            All
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            className="lqd-btn group items-center justify-center gap-1.5 font-medium rounded-button hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost bg-transparent text-foreground focus-visible:bg-foreground/10 lqd-btn-md lqd-btn-hover-none lqd-filter-btn inline-flex px-2.5 py-0.5 text-2xs leading-tight transition-colors hover:translate-y-0 hover:bg-foreground/5 [&amp;.active]:bg-foreground/5"
                                            name="filter"
                                            x-data="{}"
                                            type="button"
                                        >
                                            Favorite
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="lqd-page-content-container h-full container-fluid">
                    <div>
                        <div className="lqd-chats-list grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                            <div
                                id="1"
                                data-filter=""
                                data-title="default ai chat bot"
                                data-description="default"
                                data-favorite="false"
                                className="lqd-card text-card-foreground bg-card-background transition-all lqd-card-outline border border-card-border rounded-card lqd-chat-item group relative w-full px-16 py-8 pt-12 max-xl:px-10 border-t-0 border-s-0 border-b border-e"
                                x-init="true"
                            >
                                <div className="lqd-card-body only:grow lqd-card-size-none static">
                                    <a className="absolute left-0 top-0 z-2 block h-full w-full" href="/ai-chat-hub"></a>

                                    <a
                                        id="fav-btn-1"
                                        href="/ai-chat-hub"
                                        className="lqd-btn group inline-flex items-center justify-center gap-1.5 text-xs font-medium rounded-button transition-all hover:-translate-y-0.5 hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost-shadow bg-background text-foreground shadow-xs hover:bg-primary hover:text-primary-foreground dark:hover:bg-foreground dark:hover:text-background focus-visible:bg-primary focus-visible:text-primary-foreground dark:bg-foreground/[3%] dark:focus-visible:bg-foreground dark:focus-visible:text-background lqd-btn-size-none lqd-btn-hover-none lqd-fav-btn z-10 size-9 absolute start-4 top-4"
                                    >
                                        <span className="lqd-favorite-icon flex items-center justify-center w-4 h-4 group">
                                            <svg
                                                className="hidden h-full w-full group-[&amp;[data-is-active=true]]:block"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                stroke-width="2"
                                                stroke="currentColor"
                                                fill="none"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            >
                                                <path
                                                    d="M8.243 7.34l-6.38 .925l-.113 .023a1 1 0 0 0 -.44 1.684l4.622 4.499l-1.09 6.355l-.013 .11a1 1 0 0 0 1.464 .944l5.706 -3l5.693 3l.1 .046a1 1 0 0 0 1.352 -1.1l-1.091 -6.355l4.624 -4.5l.078 -.085a1 1 0 0 0 -.633 -1.62l-6.38 -.926l-2.852 -5.78a1 1 0 0 0 -1.794 0l-2.853 5.78z"
                                                    stroke-width="0"
                                                    fill="currentColor"
                                                ></path>
                                            </svg>
                                            <svg
                                                className="h-full w-full group-[&amp;[data-is-active=true]]:hidden"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                stroke-width="2"
                                                stroke="currentColor"
                                                fill="none"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            >
                                                <path d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z"></path>
                                            </svg>
                                        </span>
                                    </a>

                                    <div className="lqd-chat-item-details relative flex flex-col justify-center text-center">
                                        <div
                                            className="lqd-chat-item-avatar text-black/65 mx-auto mb-6 inline-flex h-32 w-32 items-center justify-center overflow-hidden overflow-ellipsis whitespace-nowrap rounded-full border-[6px] border-solid border-white/90 text-5xl font-medium shadow-[0_1px_2px_rgba(0,0,0,0.07)] transition-shadow group-hover:shadow-xl dark:border-current"
                                            style={{ background: '#a3d6c2' }}
                                        >
                                            <img className="lqd-chat-avatar-img h-full w-full object-cover object-center" src="https://sharai.net/themes/default/assets/img/chat-default.jpg" alt="Default AI Chat Bot" />
                                        </div>
                                        <div className="lqd-chat-item-info">
                                            <h3 className="lqd-chat-item-title mb-1 text-lg">
                                                Default AI Chat Bot
                                            </h3>
                                            <p className="lqd-chat-item-desc mb-0 opacity-80">
                                                Default
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                id="2"
                                data-filter=""
                                data-title="finance expert"
                                data-description="personal finance expert"
                                data-favorite="false"
                                className="d-none lqd-card text-card-foreground bg-card-background transition-all lqd-card-outline border border-card-border rounded-card lqd-chat-item group relative w-full px-16 py-8 pt-12 max-xl:px-10 border-t-0 border-s-0 border-b border-e"
                                x-init="true"
                            >
                                <div className="lqd-card-body only:grow lqd-card-size-none static">
                                    <a className="absolute left-0 top-0 z-2 block h-full w-full" href="/ai-chat-bot"></a>

                                    <a
                                        id="fav-btn-2"
                                        href="/ai-chat-bot"
                                        className="lqd-btn group inline-flex items-center justify-center gap-1.5 text-xs font-medium rounded-button transition-all hover:-translate-y-0.5 hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost-shadow bg-background text-foreground shadow-xs hover:bg-primary hover:text-primary-foreground dark:hover:bg-foreground dark:hover:text-background focus-visible:bg-primary focus-visible:text-primary-foreground dark:bg-foreground/[3%] dark:focus-visible:bg-foreground dark:focus-visible:text-background lqd-btn-size-none lqd-btn-hover-none lqd-fav-btn z-10 size-9 absolute start-4 top-4"
                                    >
                                        <span className="lqd-favorite-icon flex items-center justify-center w-4 h-4 group">
                                            <svg
                                                className="hidden h-full w-full group-[&amp;[data-is-active=true]]:block"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                stroke-width="2"
                                                stroke="currentColor"
                                                fill="none"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            >
                                                <path
                                                    d="M8.243 7.34l-6.38 .925l-.113 .023a1 1 0 0 0 -.44 1.684l4.622 4.499l-1.09 6.355l-.013 .11a1 1 0 0 0 1.464 .944l5.706 -3l5.693 3l.1 .046a1 1 0 0 0 1.352 -1.1l-1.091 -6.355l4.624 -4.5l.078 -.085a1 1 0 0 0 -.633 -1.62l-6.38 -.926l-2.852 -5.78a1 1 0 0 0 -1.794 0l-2.853 5.78z"
                                                    stroke-width="0"
                                                    fill="currentColor"
                                                ></path>
                                            </svg>
                                            <svg
                                                className="h-full w-full group-[&amp;[data-is-active=true]]:hidden"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                stroke-width="2"
                                                stroke="currentColor"
                                                fill="none"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            >
                                                <path d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z"></path>
                                            </svg>
                                        </span>
                                    </a>

                                    <div className="lqd-chat-item-details relative flex flex-col justify-center text-center">
                                        <div
                                            className="lqd-chat-item-avatar text-black/65 mx-auto mb-6 inline-flex h-32 w-32 items-center justify-center overflow-hidden overflow-ellipsis whitespace-nowrap rounded-full border-[6px] border-solid border-white/90 text-5xl font-medium shadow-[0_1px_2px_rgba(0,0,0,0.07)] transition-shadow group-hover:shadow-xl dark:border-current"
                                            style={{ background: '#dbd5f5' }}
                                        >
                                            <span className="block w-full overflow-hidden overflow-ellipsis whitespace-nowrap text-center">
                                                FE
                                            </span>
                                        </div>
                                        <div className="lqd-chat-item-info">
                                            <h3 className="lqd-chat-item-title mb-1 text-lg">
                                                Finance Expert
                                            </h3>
                                            <p className="lqd-chat-item-desc mb-0 opacity-80">
                                                Personal Finance Expert
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        </Layout>
    )
}
export default AiHub